import React, {Component} from 'react';
import './style.css'


export default class CategoriesList extends Component {
  render() {
    const idCounter = 0;
    const id = this.props.id+"_"+idCounter+1;
    console.log(id);
    const categoryElements = this.props.quote.map((quote, index) =>
        <li key={id} className="categories-list__li float-right ml-3">
          {quote}
        </li>
    )

      return (
        <ul className="categories-list__ul float-right font-weight-light text-muted mt-2 small">
          {categoryElements}
        </ul>
      )
  }
}


// export default CategoriesList


// WEBPACK FOOTER //
// ./src/components/CategoriesList/index.js